<template>
  <div class="article">
    <div class="article-model">
      <el-empty :image-size="200" v-if="!articleContent.content"></el-empty>
      <div v-html='articleContent.content?.replace(/<img src/g, "<img data-src")'
           v-lazy-container="{ selector: 'img' }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Article",
  data() {
    return {
      articleContent: {}
    }
  },
  methods: {
    // 请求文章内容
    async getArticleContent(pk) {
      this.$api.reqArticleContent(pk).then(results => {
        if (results.status === 200) {
          this.articleContent = results.results
          document.title = '新闻资讯-' + results.results.title
        } else {
          Promise.reject('error')
        }
      }).catch(() => {
        this.$message({showClose: true, message: '文章内容请求失败！', type: 'error'})
      })
    },
  },
  mounted() {
    const articleId = this.$route.params.id
    this.getArticleContent(articleId)
  },
}
</script>

<style scoped lang="less">
.article {

  .article-model {
    margin: 50px auto;
    width: 1080px;
  }
}
</style>
